import { formatDate } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { debounceTime } from 'rxjs/operators';
import { ClaveService } from 'src/app/_services/clave.service';
import { CsvgenerateService } from 'src/app/_services/csvgenerate/csvgenerate.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { ServicioGeneral } from 'src/app/_services/servicio-general.service';
import { SolicituCustomService } from 'src/app/_services/solicitud-custom.service';
import { SolicitudEmvsService } from 'src/app/_services/solicitud-emvs.service';
import { TokenStorageService } from 'src/app/_services/token-storage.service';
import { BoardAdminComponent } from 'src/app/board-admin/board-admin.component';
import { EstadoFirmaAutorizadosDialogComponent } from './dialogs/estado-firma-autorizados-dialog.component';
import { ListadoTramitesEmvsService } from './listado-tramites-emvs.service';
import { EstadoTramiteQuery, EstadoTramiteReturn, puedeConsultarFirmantesAutorizados, TramiteEmvs } from './tramite-emvs';

declare const Constants: any;

export type TramiteDto = {
  "Id": number,
  "Nombre del trámite": string,
  "Fecha alta": Date,
  "Fecha modificación": Date,
  "DNI": string,
  "Departamento": string,
  "Estado": string,
  "Acciones": object,
  "Finalizado": boolean,
  "Custom": boolean,
  "Último paso trámite"?: string
};
const today = new Date();
const month = today.getMonth();
const year = today.getFullYear();
@Component({
  selector: 'app-listado-tramites-emvs',
  templateUrl: './listado-tramites-emvs.component.html',
  styleUrls: ['./listado-tramites-emvs.component.scss'],
})
export class ListadoTramitesEmvsComponent implements OnInit {

  private readonly columnasBase = ["Nombre del trámite", "Fecha alta", "Fecha modificación", "Estado", "Último paso trámite"];
  displayedColumns: string[] = [];
  adminColumns: string[] = ["DNI"];
  private readonly colKeys: Record<string, string> = {
    'Acciones': 'TRAMITES.COL.ACCIONES',
    'Nombre del trámite': 'TRAMITES.COL.NOMBRE',
    'Fecha alta': 'TRAMITES.COL.FECHA_ALTA',
    'Fecha modificación': 'TRAMITES.COL.FECHA_MOD',
    'Estado': 'TRAMITES.COL.ESTADO',
    'Último paso trámite': 'TRAMITES.COL.ULTIMO_PASO',
    'DNI': 'TRAMITES.COL.DNI',
  };
  dataSource = new MatTableDataSource<TramiteDto>();

  get totalTramites(): number { return this.dataSource?.data?.length || 0; }
  get tramitesMostrados(): number { return this.dataSource?.filteredData?.length ?? this.totalTramites; }

  request: TramiteEmvs[];
  requestCsv: any[];

  user = this.tokenStorageService.getUser()
  userId = this.user["id"]
  isAdmin: boolean = Math.max(...this.user["rol"]) > 1;
  idCurrentPdf: number = 0;
  tramitesDto: TramiteDto[] = [];
  isInProgress: boolean = false;
  actionProgres: boolean = false;
  cargaTotal: boolean = false;
  pdfsDownload = [];
  pdfsDownloadRegen = [];
  adjuntosDownload = [];
  display: string = 'none';
  diasCaducidad: string = localStorage.getItem('tramiteMaxDays');
  estadoTramiteReturn = EstadoTramiteReturn;
  deleteCurrenTramite: TramiteEmvs = {
    id: -1
  }
  selectedTramite: any;
  selectedOpcion: String = 'Firmar con Autofirma';
  displayFirma: string = 'none';
  filteredValues: any =
    {
      DNI: '',
      Nombre: '',
      FechaDesde: '',
      FechaHasta: '',
      Estado: '',
      PasoTramite: ''
    };
  filtroDNI = new FormControl();
  filtroNombre = new FormControl();
  filtroFecha = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  })
  filtroEstado = new FormControl('');
  filtroPaso = new FormControl('');
  filtroCargaTotal = new FormControl(false);
  cargandoTramites: boolean = false;
  tabTraduccion = {
    "personales-tab": "Datos solicitante",
    "representacionReducida-tab": "Datos representante",
    "instancia-tab": "Expone/Solicita",
    "politicas-tab": "Política de privacidad",
    "representacion-tab": "Datos representante",
    "circunstancias-tab": "Circunstancias económicas",
    "unidad-tab": "Datos unidad familiar",
    "distritos-tab": "Distritos municipales",
    "vulnerabilidad-tab": "Situación vulnerabilidad",
    "autorizacion-tab": "Autorización de consulta",
    "ficheros-tab": "Carga de ficheros",
    "puestos-tab": "Puestos solicitados"
  };
  tabTraduccionB = {
    "Datos solicitante": "personales-tab",
    "Datos representante": "representacion",
    "Expone/Solicita": "instancia-tab",
    "Política de privacidad": "politicas-tab",
    "Circunstancias económicas": "circunstancias-tab",
    "Datos unidad familiar": "unidad-tab",
    "Distritos municipales": "distritos-tab",
    "Situación vulnerabilidad": "vulnerabilidad-tab",
    "Autorización de consulta": "autorizacion-tab",
    "Carga de ficheros": "ficheros-tab",
    "Puestos solicitados": "puestos-tab"
  };
  listadoEstados: any = [];
  listadoPasos: any = [];
  filtersOpen: boolean = false;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  mensajeSpinner: string;

  get activeFilterCount(): number {
    let count = 0;
    if (this.filteredValues['DNI']) count++;
    if (this.filteredValues['Nombre']) count++;
    if (this.filteredValues['FechaDesde']) count++;
    if (this.filteredValues['Estado']) count++;
    if (this.filteredValues['PasoTramite']) count++;
    if (this.filtroCargaTotal.value) count++;
    return count;
  }
  constructor(
    private listadoTramitesService: ListadoTramitesEmvsService,
    private _solicitudEmvsService: SolicitudEmvsService,
    private tokenStorageService: TokenStorageService,
    private _csvgenerate: CsvgenerateService,
    private _notificationSvc: NotificationService,
    private paginatorIntl: MatPaginatorIntl,
    private _boardAdmin: BoardAdminComponent,
    private _router: Router,
    private _servicioGeneral: ServicioGeneral,
    private _claveService: ClaveService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private _solicituCustomService: SolicituCustomService,
    private dialog: MatDialog,
    public translate: TranslateService,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.traduccionPaginator();
  }

  ngOnInit(): void {
    this.actualizarColumnasVisibles();
    this.cargaTotal = false;
    this.cargaTramites();
    this.filtroDNI.valueChanges.pipe(debounceTime(400)).subscribe((valorFiltroDNI) => {
      this.filteredValues['DNI'] = valorFiltroDNI;
      this.cargaTramites();
    });

    this.filtroNombre.valueChanges.pipe(debounceTime(400)).subscribe((valorFiltroNombre) => {
      this.filteredValues['Nombre'] = valorFiltroNombre;
      this.cargaTramites();
    });
    this.filtroFecha.controls['start'].valueChanges.pipe(debounceTime(400)).subscribe((valorFiltroFechaDesde) => {
      this.filteredValues['FechaDesde'] = valorFiltroFechaDesde;
      this.cargaTramites();
    });
    this.filtroFecha.controls['end'].valueChanges.pipe(debounceTime(400)).subscribe((valorFiltroFechaHasta) => {
      this.filteredValues['FechaHasta'] = valorFiltroFechaHasta;
      this.cargaTramites();
    });
    this.filtroEstado.valueChanges.subscribe((valorFiltroEstado) => {
      this.filteredValues['Estado'] = valorFiltroEstado;
      this.cargaTramites();
    });
    this.filtroPaso.valueChanges.subscribe((valorFiltroPaso) => {
      this.filteredValues['PasoTramite'] = valorFiltroPaso;
      this.cargaTramites();
    });
    this.filtroCargaTotal.valueChanges.subscribe((valorFiltroPaso) => {
      this.cargaTotal = valorFiltroPaso;
      this.cargaTramites();
    });


  }


  cargaTramites() {
    this.tramitesDto = [];
    this.cargandoTramites = true;
    this.mostrarSpinnerMsg(this.translate.instant('COMMON.LOADING'));
    this.listadoTramitesService.getTramitesByuserId(this.userId, this.cargaTotal,
      this.filteredValues['FechaDesde'],
      this.filteredValues['FechaHasta'],
      this.filteredValues['DNI'],
      this.filteredValues['Nombre'],
      (this.filteredValues['Estado'] ? EstadoTramiteQuery[this.filteredValues['Estado']] : this.filteredValues['Estado']),
      (this.filteredValues['PasoTramite'] && this.tabTraduccionB[this.filteredValues['PasoTramite']] ? this.tabTraduccionB[this.filteredValues['PasoTramite']] : this.filteredValues['PasoTramite']),
    ).subscribe({
      next: (data) => {
        this.request = data;
        this.request.forEach(tramite => {
          var tramiteDto: TramiteDto = {
            "Id": tramite.id,
            "Nombre del trámite": tramite.procedimiento_id.nombre,
            "Fecha alta": new Date(this.formatoFecha(tramite.fechaAlta)),
            "Fecha modificación": new Date(this.formatoFecha(tramite.fechaModificacion)),
            "DNI": tramite.usuario_id.numero_documento ?? "",
            "Departamento": tramite.procedimiento_id.departamento.nombre,
            "Estado": EstadoTramiteReturn[tramite.estadoFirma],
            "Acciones": tramite,
            "Finalizado": tramite.estado,
            "Custom": tramite.custom
          };
          if (tramite.lastVisitedTabLabel) {
            tramiteDto['Último paso trámite'] = tramite.lastVisitedTabLabel;
          }
          else {
            try {
              tramiteDto['Último paso trámite'] = this.tabTraduccion[tramite.lastVisitedTab];
            } catch (error) {
            }
          }
          this.tramitesDto.push(tramiteDto);
        });
        this.tramitesDto.forEach(
          tr => {
            let v = this.listadoEstados.filter(data => data.label == tr.Estado);
            if (v.length == 0 && tr.Estado) this.listadoEstados.push({ label: tr.Estado });
            if (tr['Último paso trámite']) {
              let p = this.listadoPasos.filter(data => data.label == tr['Último paso trámite']);
              if (p.length == 0) this.listadoPasos.push({ label: tr['Último paso trámite'] });
            }
          }
        );

        this.actualizarColumnasVisibles();
        this.dataSource = new MatTableDataSource(this.tramitesDto);
        this.dataSource.filterPredicate = this.customFilterPredicate();
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sortingDataAccessor =
          (data: object, sortHeaderId: string): string | number => {
            const propPath = sortHeaderId.split('.');
            const value: any = propPath
              .reduce((curObj, property) => curObj[property], data);
            return !isNaN(value) ? Number(value) : value;
          };
        this.cargandoTramites = false;
        /*         this.filtroDNI.setValue('');
                this.filtroNombre.setValue('');
                this.filtroFecha.controls['start'].setValue ( '');
                this.filtroFecha.controls['end'].setValue( '');
                this.filtroEstado.setValue('');
                this.filtroPaso.setValue(''); */

        this.ocultarSpinner();

      },
      error: (error) => {
        //console.log(error);
        this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('TRAMITES.MSG.LOAD_FAIL'), 3000);
        this.cargandoTramites = false;
        this.ocultarSpinner();
      }
    });
  }
  dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
    this.filteredValues['FechaDesde'] = dateRangeStart?.value;
    this.filteredValues['FechaHasta'] = dateRangeEnd?.value;
    this.dataSource.filter = JSON.stringify(this.filteredValues);
  }
  customFilterPredicate() {
    return function (data: TramiteDto, filter: string): boolean {
      let searchString = JSON.parse(filter);
      var enRango = true;
      if (searchString.FechaDesde) {
        let compareDate = new Date(data['Fecha alta']);
        compareDate.setHours(0, 0, 0, 0);
        let startDate = new Date(searchString.FechaDesde);
        startDate.setHours(0, 0, 0, 0);
        if (compareDate.getTime() >= startDate.getTime()) {
          enRango = true;
        }
        else {
          enRango = false;
        }
      }
      if (searchString.FechaHasta && enRango) {
        let compareDate = new Date(data['Fecha alta']);
        compareDate.setHours(0, 0, 0, 0);
        let endDate = new Date(searchString.FechaHasta);
        endDate.setHours(23, 59, 59, 0);
        if (compareDate.getTime() <= endDate.getTime()) {
          enRango = true;
        }
        else {
          enRango = false;
        }
      }
      return enRango
        && (!searchString.DNI || data['DNI']?.toString().toLowerCase().trim().indexOf(searchString.DNI?.toLowerCase().trim()) !== -1)
        && (!searchString.Nombre || data['Nombre del trámite']?.toString().toLowerCase().trim().toLowerCase().indexOf(searchString.Nombre?.toLowerCase().trim()) !== -1)
        && (!searchString.Estado || data['Estado']?.toString().toLowerCase().trim().toLowerCase().indexOf(searchString.Estado?.toLowerCase().trim()) !== -1)
        && (!searchString.PasoTramite || (data['Último paso trámite'] && data['Último paso trámite']?.toString().toLowerCase().trim().indexOf(searchString.PasoTramite?.toLowerCase().trim()) !== -1))
        ;
    }
  }

  formatoFecha(date) {
    if (date) {
      let month = (date[1] < 10) ? '0' + date[1] : date[1];
      let day = (date[2] < 10) ? '0' + date[2] : date[2];
      let year = date[0];
      let hour = (date[3] < 10) ? '0' + date[3] : date[3];
      let min = (date[4] < 10) ? '0' + date[4] : date[4];
      let seg = (date[5]) ? ((date[5] < 10) ? '0' + date[5] : date[5]) : '00';
      return [year, month, day].join('-').concat('T' + [hour, min, seg].join(':') + '.000Z');
    }
    return ''
  }

  formatDate(date: Date) {
    return formatDate(date, 'dd-MM-yyyy HH:mm', this.locale, 'GMT');
  }
  formatDateWithoutHour(date: Date) {
    return formatDate(date, 'dd-MM-yyyy', this.locale, 'GMT');
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  exportarCsv() {
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this._csvgenerate.generateCsvEmvs(this.request, this.filteredValues);
      this.ocultarSpinner();
    }, 100);
  }

  downloadJustificante(idNextcloud: number) {
    this.isInProgress = true;
    this.actionProgres = true;
    this.pdfsDownload.push(idNextcloud);

    this.listadoTramitesService.downloadJustificanteB64(idNextcloud).subscribe({
      next: (fichero) => {
        const linkSource = 'data:application/pdf;base64,' + fichero.Result;
        const downloadLink = document.createElement("a");
        const fileName = "tramite.pdf";

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

        this._notificationSvc.success(this.translate.instant('COMMON.DONE'), this.translate.instant('TRAMITES.MSG.PDF_OK'), 3000);
        this.isInProgress = false;

        const index: number = this.pdfsDownload.indexOf(idNextcloud);
        this.pdfsDownload.splice(index, 1);
        this.actionProgres = false;
      },
      error: (error) => {
        //console.log(error);
        this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('TRAMITES.MSG.PDF_FAIL'), 3000);

        this.actionProgres = false;
        this.isInProgress = false;
        this.pdfsDownload.splice(this.pdfsDownload.indexOf(idNextcloud), 1);
      }
    });
  }
  downloadAdjuntos(idTramite: number) {
    this.isInProgress = true;
    this.actionProgres = true;
    this.adjuntosDownload.push(idTramite);

    this.listadoTramitesService.downloadAdjuntosZip(idTramite).subscribe({
      next: (fichero) => {
        const linkSource = 'data:application/zip;base64,' + fichero.Result;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fichero.fileName ?? `adjuntos_tramite_${idTramite}.zip`;
        downloadLink.click();

        this._notificationSvc.success(this.translate.instant('COMMON.DONE'), this.translate.instant('TRAMITES.MSG.ATTACH_OK'), 3000);
        this.isInProgress = false;
        this.adjuntosDownload.splice(this.adjuntosDownload.indexOf(idTramite), 1);
        this.actionProgres = false;
      },
      error: (error) => {
        if (error?.status === 404) {
          this._notificationSvc.warning(this.translate.instant('COMMON.WARNING'), this.translate.instant('TRAMITES.MSG.ATTACH_EMPTY'), 3000);
        } else {
          this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('TRAMITES.MSG.ATTACH_FAIL'), 3000);
        }
        this.actionProgres = false;
        this.isInProgress = false;
        this.adjuntosDownload.splice(this.adjuntosDownload.indexOf(idTramite), 1);
      }
    });
  }

  downloadJustificanteRegen(idTramite: number) {
    this.isInProgress = true;
    this.actionProgres = true;
    this.pdfsDownloadRegen.push(idTramite);

    this._servicioGeneral.generatePdf(idTramite).subscribe({


      next: (fichero: any) => {
        const linkSource = 'data:application/pdf;base64,' + fichero.file;
        const downloadLink = document.createElement("a");
        const fileName = "tramite.pdf";

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

        this._notificationSvc.success(this.translate.instant('COMMON.DONE'), this.translate.instant('TRAMITES.MSG.PDF_OK'), 3000);
        this.isInProgress = false;

        const index: number = this.pdfsDownloadRegen.indexOf(idTramite);
        this.pdfsDownloadRegen.splice(index, 1);
        this.actionProgres = false;
      },
      error: (error) => {
        //console.log(error);
        this._notificationSvc.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('TRAMITES.MSG.PDF_FAIL'), 3000);

        this.actionProgres = false;
        this.isInProgress = false;
        this.pdfsDownloadRegen.splice(this.pdfsDownloadRegen.indexOf(idTramite), 1);
      }
    });
  }
  private traduccionPaginator(): void {
    this.paginatorIntl.itemsPerPageLabel = "Registros por página";
    this.paginatorIntl.firstPageLabel = '';
    this.paginatorIntl.previousPageLabel = '';
    this.paginatorIntl.nextPageLabel = '';
    this.paginatorIntl.lastPageLabel = '';
    this.paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return `0 de ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
      return `${startIndex + 1} - ${endIndex} de ${length}`;
    };
  }
  post(path: string, params: any): void {
    let method = "post";
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  }


  public downloadPdf(base64Document, fileName) {
    const source = 'data:application/pdf;base64,' + base64Document;
    const link = document.createElement("a");
    link.href = source;
    link.download = `${fileName}.pdf`
    link.click();
  }

  public valuesEnum(object): boolean {
    return Object.values(this.estadoTramiteReturn).includes(object)
  }

  signTramite(tramite: any) {
    this.displayFirma = 'block';
    this.selectedTramite = tramite;
  }

  public pdfProcedimientoClave(rId: string, accion: string, tramite: string) {
    if (accion == 'firmar' && rId && tramite) {
      this.actionProgres = true;
      this._claveService.getResultFirma(rId).subscribe({
        next: (data: any) => {
          if (data.status && data.status == '658') {
            this.listadoTramitesService.getTramiteById(Number(tramite)).subscribe({
              next: (data: any) => {
                this._solicitudEmvsService.updateEstadoTramiteById(data.id).subscribe({
                  next: (data: any) => {
                    if (data.estadoFirma == 'FIRMADO_CON_REGISTRO') {
                      this.downloadPdf(data.pdfFirmado, 'comprobante_solicitud_tramite');
                      this.actionProgres = false;
                      this._notificationSvc.success(this.translate.instant('COMMON.DONE'), this.translate.instant('TRAMITES.MSG.PDF_SIGNED'));
                      this.limpiarParametros();
                      this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
                    }
                    else {
                      this._notificationSvc.warning(this.translate.instant('COMMON.WARNING'), this.translate.instant('TRAMITES.MSG.REGISTRO_FAIL'));
                      this.limpiarParametros();
                      this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
                      this.actionProgres = false;
                    }
                  },
                  error: (error) => {
                    this._notificationSvc.warning(this.translate.instant('COMMON.WARNING'), this.translate.instant('TRAMITES.MSG.REGISTRO_FAIL'));
                    this.limpiarParametros();
                    this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
                    this.actionProgres = false;
                  }
                });
              },
              error: (error) => {
                this._notificationSvc.warning(this.translate.instant('COMMON.WARNING'), this.translate.instant('TRAMITES.MSG.NOT_FOUND_SIGN'));
                this.limpiarParametros();
                this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
                this.actionProgres = false;
              }
            });
          }
          else {
            this._notificationSvc.warning(this.translate.instant('COMMON.WARNING'), this.translate.instant('TRAMITES.MSG.AUTH_ID_INVALID'));
            this.limpiarParametros();
            this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
            this.actionProgres = false;
          }
        },
        error: (error) => {
          this._notificationSvc.warning(this.translate.instant('COMMON.WARNING'), this.translate.instant('TRAMITES.MSG.AUTH_ID_ERROR'));
          this.limpiarParametros();
          this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
          this.actionProgres = false;
        }

      });
    }
  }
  limpiarParametros() {
    this._router.navigate([], {
      queryParams: {
        'rId': null,
        'a': null,
        't': null,
      },
      queryParamsHandling: 'merge'
    });
  }
  cargarMas() {
    const newSize = this.paginator.pageSize + 10;
    this.paginator.pageSize = newSize;
    this.dataSource.paginator = this.paginator;
  }

  clearFilters() {
    this.filtroDNI.setValue('');
    this.filtroNombre.setValue('');
    this.filtroFecha.reset();
    this.filtroEstado.setValue('');
    this.filtroPaso.setValue('');
    this.filtroCargaTotal.setValue(false);
  }

  mostrarSpinnerMsg(mensaje: string) {
    this.mensajeSpinner = mensaje;
    this.spinner.show('litado_tramites_spinner');
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide('litado_tramites_spinner');
    }, 60000);
  }
  ocultarSpinner() {
    this.spinner.hide('litado_tramites_spinner');
  }

  colLabel(column: string): string {
    const key = this.colKeys[column];
    return key ? this.translate.instant(key) : column;
  }

  actualizarColumnasVisibles(): void {
    const cols = [...this.adminColumns, ...this.columnasBase];
    if (this.hayAccionesEnTabla()) {
      cols.push('Acciones');
    }
    this.displayedColumns = cols;
  }

  hayAccionesEnTabla(): boolean {
    return this.tramitesDto.some(t => this.tieneAccionTramite(t.Acciones));
  }

  tieneAccionTramite(tramite: any): boolean {
    // La descarga de adjuntos está disponible para cualquier trámite,
    // por lo que toda fila tiene al menos una acción.
    return !!tramite;
  }

  puedeVerFirmantesAutorizados(tramite: TramiteEmvs): boolean {
    return puedeConsultarFirmantesAutorizados(tramite);
  }

  abrirEstadoFirmaAutorizados(tramite: any, nombreTramite: string): void {
    this.dialog.open(EstadoFirmaAutorizadosDialogComponent, {
      data: {
        tramiteId: tramite.id,
        nombreTramite
      },
      panelClass: 'gu-dialog-panel',
      autoFocus: false
    });
  }
}